// AUTOGENERATED — do not edit!

import {
  Icon16Favorite,
  Icon16FavoriteOutline,
  Icon20FavoriteOutline,
  Icon16ErrorCircleOutline,
  Icon20ErrorCircleOutline,
  Icon24ErrorCircleOutline,
  Icon24AddOutline,
  Icon20HelpOutline,
  Icon16HelpOutline,
  Icon24HelpOutline,
  Icon16ArrowUturnLeftOutline,
  Icon20ArrowUturnLeftOutline,
  Icon16RepostOutline,
  Icon24ChevronRightSmallOutline,
  Icon28CrossLargeOutline,
  Icon28TablecellsOutline,
  Icon24CalendarOutline,
  Icon16CalendarOutline,
  Icon20CalendarOutline,
  Icon24ChevronDown,
  Icon16MoreVertical,
  Icon24MoreVertical,
  Icon20Write,
  Icon16ArrowUpCircle,
  Icon12View,
  Icon16View,
  Icon24View,
  Icon16CrossCircleSmall,
  Icon12ArrowRight,
  Icon24DismissOverlay,
  Icon24DotsVertical,
  Icon16PenOutline,
  Icon16DeleteOutline,
  Icon24DeleteOutline,
  Icon20DeleteOutline,
  Icon24Add,
  Icon20Add,
  Icon16Add,
  Icon12Add,
  Icon20CircleSmallFilled,
  Icon24CopyOutline,
  Icon20CopyOutline,
  Icon16Users2Outline,
  Icon16Chevron,
  Icon24Attach,
  Icon16Attach,
  Icon20Attach,
  Icon24InfoCircleOutline,
  Icon20InfoCircleOutline,
  Icon16LockOutline,
  Icon20LockOutline,
  Icon24Document,
  Icon16DownloadOutline,
  Icon20DownloadOutline,
  Icon24DownloadOutline,
  Icon24ChevronUpSmall,
  Icon24ChevronDownSmall,
  Icon24Done,
  Icon16Done,
  Icon20IncognitoOutline,
  Icon24IncognitoOutline,
  Icon20UsersOutline,
  Icon24UsersOutline,
  Icon16BuildingOutline,
  Icon24BuildingOutline,
  Icon20BuildingOutline,
  Icon16ViewOutline,
  Icon20ViewOutline,
  Icon16HideOutline,
  Icon16StarAlt,
  Icon24Refresh,
  Icon20CircleSmall,
  Icon16DoneCircle,
  Icon16Poll,
  Icon16CheckCircleLarge,
  Icon16Pen,
  Icon16PictureOutline,
  Icon24PictureOutline,
  Icon20PictureOutline,
  Icon16ArrowTriangleUp,
  Icon16ArrowTriangleDown,
  Icon24User,
  Icon16User,
  Icon16Block,
  Icon24Block,
  Icon16SearchOutline,
  Icon16Cancel,
  Icon20Cancel,
  Icon24Cancel,
  Icon16ArrowbranchOutline,
  Icon20OnOffOutline,
  Icon20BlockOutline,
  Icon20CheckCircleOutline,
  Icon28CheckCircleOutline,
  Icon16Clock,
  Icon24Clock,
  Icon16DropdownFlippedOutline,
  Icon16DropdownOutline,
  Icon16ErrorCircleFill,
  Icon24MinusOutline,
  Icon20MinusOutline,
  Icon24FlashOutline,
  Icon20FlashOutline,
  Icon24Cards2Outline,
  Icon24DocumentOutline,
  Icon20DocumentOutline,
  Icon24ListBulletOutline,
  Icon24ListBulletSquareOutline,
  Icon16Phone,
  Icon16MailOutline,
  Icon20MailOutline,
  Icon16GearOutline,
  Icon20GearOutline,
  Icon20UserCircleOutline,
  Icon16Pin,
  Icon12Pin,
  Icon16PinOutline,
  Icon24Advertising,
  Icon28ChevronDownOutline,
  Icon20ChevronUpOutline,
  Icon16DropdownFlipped,
  Icon16Dropdown,
  Icon12Dropdown,
  Icon24Dropdown,
  Icon20Dropdown,
  Icon16PopUpStickerOutline,
  Icon20HomeOutline,
  Icon20AdvertisingOutline,
  Icon24AdvertisingOutline,
  Icon20Grid4UnevenVerticalOutline,
  Icon20Rectangle2HorizontalOutline,
  Icon20NarrativeOutline,
  Icon24NarrativeOutline,
  Icon20GlobeOutline,
  Icon24GlobeOutline,
  Icon16GlobeOutline,
  Icon20BookmarkOutline,
  Icon16BookmarkOutline,
  Icon24BookmarkOutline,
  Icon20ArticleBoxOutline,
  Icon20Users3Outline,
  Icon24Users3Outline,
  Icon20UserSquareOnSquareOutline,
  Icon20UserSquareOutline,
  Icon20WalletOutline,
  Icon24WalletOutline,
  Icon20UserCheckOutline,
  Icon28HandHeartOutline,
  Icon20LogoVkAdsOutline,
  Icon20PlaneOutline,
  Icon24PlaneOutline,
  Icon20CupOutline,
  Icon24CupOutline,
  Icon24BriefcaseOutline,
  Icon20UserOutline,
  Icon24UserOutline,
  Icon20Hearts2Outline,
  Icon20NotebookCheckOutline,
  Icon20VideoSquareOutline,
  Icon16VideoSquareOutline,
  Icon20RectangleInfoOutline,
  Icon20EducationOutline,
  Icon24EducationOutline,
  Icon20LightbulbOutline,
  Icon20ThermometerOutline,
  Icon20Chain,
  Icon20PhoneOutline,
  Icon16PhoneOutline,
  Icon20BookSpreadOutline,
  Icon20CalendarCheckOutline,
  Icon16Comment,
  Icon16LikeOutline,
  Icon20LikeOutline,
  Icon24LikeOutline,
  Icon20CheckSquareOutline,
  Icon20ArticleOutline,
  Icon28HappyFaceOutline,
  Icon20AlarmOutline,
  Icon24ChevronUp,
  Icon12ChevronUp,
  Icon20ChevronUp,
  Icon20ChevronRightOutline,
  Icon24ChevronRightOutline,
  Icon28ChevronRightOutline,
  Icon20PrinterOutline,
  Icon24PrinterOutline,
  Icon24Filter,
  Icon16GridOfFour,
  Icon16DoorEnterArrowRightOutline,
  Icon20ChevronLeft2,
  Icon20ChevronRight2,
  Icon12ChevronRight,
  Icon20ChevronRight,
  Icon24MenuOutline,
  Icon24CommentAlt,
  Icon24DismissSubstract,
  Icon24CheckCircleOn,
  Icon20CheckCircleOn,
  Icon24CancelOutline,
  Icon24RefreshOutline,
  Icon16RefreshOutline,
  Icon16LinkOutline,
  Icon24ServicesOutline,
  Icon20CommentOutline,
  Icon16CommentOutline,
  Icon20SmileOutline,
  Icon24Bookmark,
  Icon20Bookmark,
  Icon16Bookmark,
  Icon20FunnelOutline,
  Icon16Users,
  Icon20ListInsertFirstOutline,
  Icon28ErrorOutline,
  Icon16Dash,
  Icon20Check,
  Icon16CheckCircle,
  Icon24DocumentTextOutline,
  Icon20DocumentTextOutline,
  Icon24ChainOutline,
  Icon16ChainOutline,
  Icon24ComputerSmartphoneOutline,
  Icon20UserStarOutline,
  Icon24ExternalLinkOutline,
  Icon20CakeOutline,
  Icon24Square4PlusOutline,
  Icon24Delete,
  Icon16UserCircleAltOutline,
  Icon16ArrowLeftOutline,
  Icon12ErrorCircleFillGray,
  Icon24ErrorCircleFillGray,
  Icon20DoorArrowRightOutline,
  Icon16Search,
  Icon24Search,
  Icon20UserStarBadgeOutline,
  Icon16Linked,
  Icon24Linked,
  Icon16ReplyOutline,
  Icon24Help,
  Icon28CancelCircleOutline,
  Icon20SortOutline,
  Icon24NotificationSubtractOutline,
  Icon24NotificationOutline,
  Icon28Rectangle2Outline,
  Icon16ChevronLeft,
  Icon24CalendarAddOutline,
  Icon24SendOutline,
  Icon16TextViewfinderOutline,
  Icon20PictureStackOutline,
  Icon24ChevronLeftSmallOutline,
  Icon28ListOutline,
  Icon20ListNumberOutline,
  Icon20IndentDecreaseOutline,
  Icon20IndentIncreaseOutline,
  Icon28TextLeftOutline,
  Icon20TextCenterOutline,
  Icon20TextRightOutline,
  Icon20TableHeaderOutline,
  Icon12QuoteClosing,
  Icon16TextBoldOutline,
  Icon16TextItalicOutline,
  Icon16TextUnderlineOutline,
  Icon16TextStrikethroughOutline,
  Icon20MarkerOutline,
  Icon24Hide,
  Icon20MoreHorizontal,
  Icon16MoreHorizontal,
  Icon24MoreHorizontal,
  Icon20Square4Outline,
  Icon24StarsOutline,
  Icon12Star,
  Icon24RadioOff,
  Icon24RadioOn,
  Icon20RotateLeft,
  Icon28RotateLeftOutline,
  Icon20CircleOutline,
  Icon20ArrowUpOutline,
  Icon16CheckOutline,
  Icon28FullscreenOutline,
  Icon20FullscreenOutline,
  Icon28HeartCircleOutline,
  Icon20PictureSlashOutline,
  Icon24ChevronLeftOutline,
  Icon28ChevronLeftOutline,
  Icon16ArrowRightOutline,
  Icon20MagnifierMinusOutline,
  Icon20MagnifierPlusOutline,
  Icon20ArrowUpRightOutline,
  Icon20ErrorCircle,
  Icon28InfoCircle,
  Icon24CheckBoxOff,
  Icon24CheckBoxOn,
  Icon20CheckBoxIndetermanate,
  Icon20ChecksSmallOutline,
  Icon16ClockCircleFill,
  Icon24PlaceOutline,
  Icon16FireAlt,
  Icon24Flash,
  Icon24FlagStart,
  Icon20StarsFilled,
  Icon20LogoGeekbrainsOutline,
  Icon24BooksOutline,
  Icon24PhotosStackOutline,
  Icon24FolderSimpleOutline,
  Icon24FolderSimpleUserOutline,
  Icon24DocumentStatsOutline,
  Icon24RepeatOutline,
  Icon24FolderOutline,
  Icon24FlapperOutline,
  Icon20SlidersOutline,
  Icon24ArrowLeftRightCornersOutline,
  Icon24FlagFinish,
} from '@vkontakte/icons';

export const vkIconsMap = {
  favorite: {
    16: Icon16Favorite,
  },
  favorite_outline: {
    16: Icon16FavoriteOutline,
    20: Icon20FavoriteOutline,
  },
  error_circle_outline: {
    16: Icon16ErrorCircleOutline,
    20: Icon20ErrorCircleOutline,
    24: Icon24ErrorCircleOutline,
  },
  add_outline: {
    24: Icon24AddOutline,
  },
  help_outline: {
    16: Icon16HelpOutline,
    20: Icon20HelpOutline,
    24: Icon24HelpOutline,
  },
  arrow_uturn_left_outline: {
    16: Icon16ArrowUturnLeftOutline,
    20: Icon20ArrowUturnLeftOutline,
  },
  repost_outline: {
    16: Icon16RepostOutline,
  },
  chevron_right_small_outline: {
    24: Icon24ChevronRightSmallOutline,
  },
  cross_large_outline: {
    28: Icon28CrossLargeOutline,
  },
  tablecells_outline: {
    28: Icon28TablecellsOutline,
  },
  calendar_outline: {
    16: Icon16CalendarOutline,
    20: Icon20CalendarOutline,
    24: Icon24CalendarOutline,
  },
  chevron_down: {
    24: Icon24ChevronDown,
  },
  more_vertical: {
    16: Icon16MoreVertical,
    24: Icon24MoreVertical,
  },
  write: {
    20: Icon20Write,
  },
  arrow_up_circle: {
    16: Icon16ArrowUpCircle,
  },
  view: {
    12: Icon12View,
    16: Icon16View,
    24: Icon24View,
  },
  cross_circle_small: {
    16: Icon16CrossCircleSmall,
  },
  arrow_right: {
    12: Icon12ArrowRight,
  },
  dismiss_overlay: {
    24: Icon24DismissOverlay,
  },
  dots_vertical: {
    24: Icon24DotsVertical,
  },
  pen_outline: {
    16: Icon16PenOutline,
  },
  delete_outline: {
    16: Icon16DeleteOutline,
    20: Icon20DeleteOutline,
    24: Icon24DeleteOutline,
  },
  add: {
    12: Icon12Add,
    16: Icon16Add,
    20: Icon20Add,
    24: Icon24Add,
  },
  circle_small_filled: {
    20: Icon20CircleSmallFilled,
  },
  copy_outline: {
    20: Icon20CopyOutline,
    24: Icon24CopyOutline,
  },
  users_2_outline: {
    16: Icon16Users2Outline,
  },
  chevron: {
    16: Icon16Chevron,
  },
  attach: {
    16: Icon16Attach,
    20: Icon20Attach,
    24: Icon24Attach,
  },
  info_circle_outline: {
    20: Icon20InfoCircleOutline,
    24: Icon24InfoCircleOutline,
  },
  lock_outline: {
    16: Icon16LockOutline,
    20: Icon20LockOutline,
  },
  document: {
    24: Icon24Document,
  },
  download_outline: {
    16: Icon16DownloadOutline,
    20: Icon20DownloadOutline,
    24: Icon24DownloadOutline,
  },
  chevron_up_small: {
    24: Icon24ChevronUpSmall,
  },
  chevron_down_small: {
    24: Icon24ChevronDownSmall,
  },
  done: {
    16: Icon16Done,
    24: Icon24Done,
  },
  incognito_outline: {
    20: Icon20IncognitoOutline,
    24: Icon24IncognitoOutline,
  },
  users_outline: {
    20: Icon20UsersOutline,
    24: Icon24UsersOutline,
  },
  building_outline: {
    16: Icon16BuildingOutline,
    20: Icon20BuildingOutline,
    24: Icon24BuildingOutline,
  },
  view_outline: {
    16: Icon16ViewOutline,
    20: Icon20ViewOutline,
  },
  hide_outline: {
    16: Icon16HideOutline,
  },
  star_alt: {
    16: Icon16StarAlt,
  },
  refresh: {
    24: Icon24Refresh,
  },
  circle_small: {
    20: Icon20CircleSmall,
  },
  done_circle: {
    16: Icon16DoneCircle,
  },
  poll: {
    16: Icon16Poll,
  },
  check_circle_large: {
    16: Icon16CheckCircleLarge,
  },
  pen: {
    16: Icon16Pen,
  },
  picture_outline: {
    16: Icon16PictureOutline,
    20: Icon20PictureOutline,
    24: Icon24PictureOutline,
  },
  arrow_triangle_up: {
    16: Icon16ArrowTriangleUp,
  },
  arrow_triangle_down: {
    16: Icon16ArrowTriangleDown,
  },
  user: {
    16: Icon16User,
    24: Icon24User,
  },
  block: {
    16: Icon16Block,
    24: Icon24Block,
  },
  search_outline: {
    16: Icon16SearchOutline,
  },
  cancel: {
    16: Icon16Cancel,
    20: Icon20Cancel,
    24: Icon24Cancel,
  },
  arrowbranch_outline: {
    16: Icon16ArrowbranchOutline,
  },
  on_off_outline: {
    20: Icon20OnOffOutline,
  },
  block_outline: {
    20: Icon20BlockOutline,
  },
  check_circle_outline: {
    20: Icon20CheckCircleOutline,
    28: Icon28CheckCircleOutline,
  },
  clock: {
    16: Icon16Clock,
    24: Icon24Clock,
  },
  dropdown_flipped_outline: {
    16: Icon16DropdownFlippedOutline,
  },
  dropdown_outline: {
    16: Icon16DropdownOutline,
  },
  error_circle_fill: {
    16: Icon16ErrorCircleFill,
  },
  minus_outline: {
    20: Icon20MinusOutline,
    24: Icon24MinusOutline,
  },
  flash_outline: {
    20: Icon20FlashOutline,
    24: Icon24FlashOutline,
  },
  cards_2_outline: {
    24: Icon24Cards2Outline,
  },
  document_outline: {
    20: Icon20DocumentOutline,
    24: Icon24DocumentOutline,
  },
  list_bullet_outline: {
    24: Icon24ListBulletOutline,
  },
  list_bullet_square_outline: {
    24: Icon24ListBulletSquareOutline,
  },
  phone: {
    16: Icon16Phone,
  },
  mail_outline: {
    16: Icon16MailOutline,
    20: Icon20MailOutline,
  },
  gear_outline: {
    16: Icon16GearOutline,
    20: Icon20GearOutline,
  },
  user_circle_outline: {
    20: Icon20UserCircleOutline,
  },
  pin: {
    12: Icon12Pin,
    16: Icon16Pin,
  },
  pin_outline: {
    16: Icon16PinOutline,
  },
  advertising: {
    24: Icon24Advertising,
  },
  chevron_down_outline: {
    28: Icon28ChevronDownOutline,
  },
  chevron_up_outline: {
    20: Icon20ChevronUpOutline,
  },
  dropdown_flipped: {
    16: Icon16DropdownFlipped,
  },
  dropdown: {
    12: Icon12Dropdown,
    16: Icon16Dropdown,
    20: Icon20Dropdown,
    24: Icon24Dropdown,
  },
  pop_up_sticker_outline: {
    16: Icon16PopUpStickerOutline,
  },
  home_outline: {
    20: Icon20HomeOutline,
  },
  advertising_outline: {
    20: Icon20AdvertisingOutline,
    24: Icon24AdvertisingOutline,
  },
  grid_4_uneven_vertical_outline: {
    20: Icon20Grid4UnevenVerticalOutline,
  },
  rectangle_2_horizontal_outline: {
    20: Icon20Rectangle2HorizontalOutline,
  },
  narrative_outline: {
    20: Icon20NarrativeOutline,
    24: Icon24NarrativeOutline,
  },
  globe_outline: {
    16: Icon16GlobeOutline,
    20: Icon20GlobeOutline,
    24: Icon24GlobeOutline,
  },
  bookmark_outline: {
    16: Icon16BookmarkOutline,
    20: Icon20BookmarkOutline,
    24: Icon24BookmarkOutline,
  },
  article_box_outline: {
    20: Icon20ArticleBoxOutline,
  },
  users_3_outline: {
    20: Icon20Users3Outline,
    24: Icon24Users3Outline,
  },
  user_square_on_square_outline: {
    20: Icon20UserSquareOnSquareOutline,
  },
  user_square_outline: {
    20: Icon20UserSquareOutline,
  },
  wallet_outline: {
    20: Icon20WalletOutline,
    24: Icon24WalletOutline,
  },
  user_check_outline: {
    20: Icon20UserCheckOutline,
  },
  hand_heart_outline: {
    28: Icon28HandHeartOutline,
  },
  logo_vk_ads_outline: {
    20: Icon20LogoVkAdsOutline,
  },
  plane_outline: {
    20: Icon20PlaneOutline,
    24: Icon24PlaneOutline,
  },
  cup_outline: {
    20: Icon20CupOutline,
    24: Icon24CupOutline,
  },
  briefcase_outline: {
    24: Icon24BriefcaseOutline,
  },
  user_outline: {
    20: Icon20UserOutline,
    24: Icon24UserOutline,
  },
  hearts_2_outline: {
    20: Icon20Hearts2Outline,
  },
  notebook_check_outline: {
    20: Icon20NotebookCheckOutline,
  },
  video_square_outline: {
    16: Icon16VideoSquareOutline,
    20: Icon20VideoSquareOutline,
  },
  rectangle_info_outline: {
    20: Icon20RectangleInfoOutline,
  },
  education_outline: {
    20: Icon20EducationOutline,
    24: Icon24EducationOutline,
  },
  lightbulb_outline: {
    20: Icon20LightbulbOutline,
  },
  thermometer_outline: {
    20: Icon20ThermometerOutline,
  },
  chain: {
    20: Icon20Chain,
  },
  phone_outline: {
    16: Icon16PhoneOutline,
    20: Icon20PhoneOutline,
  },
  book_spread_outline: {
    20: Icon20BookSpreadOutline,
  },
  calendar_check_outline: {
    20: Icon20CalendarCheckOutline,
  },
  comment: {
    16: Icon16Comment,
  },
  like_outline: {
    16: Icon16LikeOutline,
    20: Icon20LikeOutline,
    24: Icon24LikeOutline,
  },
  check_square_outline: {
    20: Icon20CheckSquareOutline,
  },
  article_outline: {
    20: Icon20ArticleOutline,
  },
  happy_face_outline: {
    28: Icon28HappyFaceOutline,
  },
  alarm_outline: {
    20: Icon20AlarmOutline,
  },
  chevron_up: {
    12: Icon12ChevronUp,
    20: Icon20ChevronUp,
    24: Icon24ChevronUp,
  },
  chevron_right_outline: {
    20: Icon20ChevronRightOutline,
    24: Icon24ChevronRightOutline,
    28: Icon28ChevronRightOutline,
  },
  printer_outline: {
    20: Icon20PrinterOutline,
    24: Icon24PrinterOutline,
  },
  filter: {
    24: Icon24Filter,
  },
  grid_of_four: {
    16: Icon16GridOfFour,
  },
  door_enter_arrow_right_outline: {
    16: Icon16DoorEnterArrowRightOutline,
  },
  chevron_left_2: {
    20: Icon20ChevronLeft2,
  },
  chevron_right_2: {
    20: Icon20ChevronRight2,
  },
  chevron_right: {
    12: Icon12ChevronRight,
    20: Icon20ChevronRight,
  },
  menu_outline: {
    24: Icon24MenuOutline,
  },
  comment_alt: {
    24: Icon24CommentAlt,
  },
  dismiss_substract: {
    24: Icon24DismissSubstract,
  },
  check_circle_on: {
    20: Icon20CheckCircleOn,
    24: Icon24CheckCircleOn,
  },
  cancel_outline: {
    24: Icon24CancelOutline,
  },
  refresh_outline: {
    16: Icon16RefreshOutline,
    24: Icon24RefreshOutline,
  },
  link_outline: {
    16: Icon16LinkOutline,
  },
  services_outline: {
    24: Icon24ServicesOutline,
  },
  comment_outline: {
    16: Icon16CommentOutline,
    20: Icon20CommentOutline,
  },
  smile_outline: {
    20: Icon20SmileOutline,
  },
  bookmark: {
    16: Icon16Bookmark,
    20: Icon20Bookmark,
    24: Icon24Bookmark,
  },
  funnel_outline: {
    20: Icon20FunnelOutline,
  },
  users: {
    16: Icon16Users,
  },
  list_insert_first_outline: {
    20: Icon20ListInsertFirstOutline,
  },
  error_outline: {
    28: Icon28ErrorOutline,
  },
  dash: {
    16: Icon16Dash,
  },
  check: {
    20: Icon20Check,
  },
  check_circle: {
    16: Icon16CheckCircle,
  },
  document_text_outline: {
    20: Icon20DocumentTextOutline,
    24: Icon24DocumentTextOutline,
  },
  chain_outline: {
    16: Icon16ChainOutline,
    24: Icon24ChainOutline,
  },
  computer_smartphone_outline: {
    24: Icon24ComputerSmartphoneOutline,
  },
  user_star_outline: {
    20: Icon20UserStarOutline,
  },
  external_link_outline: {
    24: Icon24ExternalLinkOutline,
  },
  cake_outline: {
    20: Icon20CakeOutline,
  },
  square_4_plus_outline: {
    24: Icon24Square4PlusOutline,
  },
  delete: {
    24: Icon24Delete,
  },
  user_circle_alt_outline: {
    16: Icon16UserCircleAltOutline,
  },
  arrow_left_outline: {
    16: Icon16ArrowLeftOutline,
  },
  error_circle_fill_gray: {
    12: Icon12ErrorCircleFillGray,
    24: Icon24ErrorCircleFillGray,
  },
  door_arrow_right_outline: {
    20: Icon20DoorArrowRightOutline,
  },
  search: {
    16: Icon16Search,
    24: Icon24Search,
  },
  user_star_badge_outline: {
    20: Icon20UserStarBadgeOutline,
  },
  linked: {
    16: Icon16Linked,
    24: Icon24Linked,
  },
  reply_outline: {
    16: Icon16ReplyOutline,
  },
  help: {
    24: Icon24Help,
  },
  cancel_circle_outline: {
    28: Icon28CancelCircleOutline,
  },
  sort_outline: {
    20: Icon20SortOutline,
  },
  notification_subtract_outline: {
    24: Icon24NotificationSubtractOutline,
  },
  notification_outline: {
    24: Icon24NotificationOutline,
  },
  rectangle_2_outline: {
    28: Icon28Rectangle2Outline,
  },
  chevron_left: {
    16: Icon16ChevronLeft,
  },
  calendar_add_outline: {
    24: Icon24CalendarAddOutline,
  },
  send_outline: {
    24: Icon24SendOutline,
  },
  text_viewfinder_outline: {
    16: Icon16TextViewfinderOutline,
  },
  picture_stack_outline: {
    20: Icon20PictureStackOutline,
  },
  chevron_left_small_outline: {
    24: Icon24ChevronLeftSmallOutline,
  },
  list_outline: {
    28: Icon28ListOutline,
  },
  list_number_outline: {
    20: Icon20ListNumberOutline,
  },
  indent_decrease_outline: {
    20: Icon20IndentDecreaseOutline,
  },
  indent_increase_outline: {
    20: Icon20IndentIncreaseOutline,
  },
  text_left_outline: {
    28: Icon28TextLeftOutline,
  },
  text_center_outline: {
    20: Icon20TextCenterOutline,
  },
  text_right_outline: {
    20: Icon20TextRightOutline,
  },
  table_header_outline: {
    20: Icon20TableHeaderOutline,
  },
  quote_closing: {
    12: Icon12QuoteClosing,
  },
  text_bold_outline: {
    16: Icon16TextBoldOutline,
  },
  text_italic_outline: {
    16: Icon16TextItalicOutline,
  },
  text_underline_outline: {
    16: Icon16TextUnderlineOutline,
  },
  text_strikethrough_outline: {
    16: Icon16TextStrikethroughOutline,
  },
  marker_outline: {
    20: Icon20MarkerOutline,
  },
  hide: {
    24: Icon24Hide,
  },
  more_horizontal: {
    16: Icon16MoreHorizontal,
    20: Icon20MoreHorizontal,
    24: Icon24MoreHorizontal,
  },
  square_4_outline: {
    20: Icon20Square4Outline,
  },
  stars_outline: {
    24: Icon24StarsOutline,
  },
  star: {
    12: Icon12Star,
  },
  radio_off: {
    24: Icon24RadioOff,
  },
  radio_on: {
    24: Icon24RadioOn,
  },
  rotate_left: {
    20: Icon20RotateLeft,
  },
  rotate_left_outline: {
    28: Icon28RotateLeftOutline,
  },
  circle_outline: {
    20: Icon20CircleOutline,
  },
  arrow_up_outline: {
    20: Icon20ArrowUpOutline,
  },
  check_outline: {
    16: Icon16CheckOutline,
  },
  fullscreen_outline: {
    20: Icon20FullscreenOutline,
    28: Icon28FullscreenOutline,
  },
  heart_circle_outline: {
    28: Icon28HeartCircleOutline,
  },
  picture_slash_outline: {
    20: Icon20PictureSlashOutline,
  },
  chevron_left_outline: {
    24: Icon24ChevronLeftOutline,
    28: Icon28ChevronLeftOutline,
  },
  arrow_right_outline: {
    16: Icon16ArrowRightOutline,
  },
  magnifier_minus_outline: {
    20: Icon20MagnifierMinusOutline,
  },
  magnifier_plus_outline: {
    20: Icon20MagnifierPlusOutline,
  },
  arrow_up_right_outline: {
    20: Icon20ArrowUpRightOutline,
  },
  error_circle: {
    20: Icon20ErrorCircle,
  },
  info_circle: {
    28: Icon28InfoCircle,
  },
  check_box_off: {
    24: Icon24CheckBoxOff,
  },
  check_box_on: {
    24: Icon24CheckBoxOn,
  },
  check_box_indetermanate: {
    20: Icon20CheckBoxIndetermanate,
  },
  checks_small_outline: {
    20: Icon20ChecksSmallOutline,
  },
  clock_circle_fill: {
    16: Icon16ClockCircleFill,
  },
  place_outline: {
    24: Icon24PlaceOutline,
  },
  fire_alt: {
    16: Icon16FireAlt,
  },
  flash: {
    24: Icon24Flash,
  },
  flag_start: {
    24: Icon24FlagStart,
  },
  stars_filled: {
    20: Icon20StarsFilled,
  },
  logo_geekbrains_outline: {
    20: Icon20LogoGeekbrainsOutline,
  },
  books_outline: {
    24: Icon24BooksOutline,
  },
  photos_stack_outline: {
    24: Icon24PhotosStackOutline,
  },
  folder_simple_outline: {
    24: Icon24FolderSimpleOutline,
  },
  folder_simple_user_outline: {
    24: Icon24FolderSimpleUserOutline,
  },
  document_stats_outline: {
    24: Icon24DocumentStatsOutline,
  },
  repeat_outline: {
    24: Icon24RepeatOutline,
  },
  folder_outline: {
    24: Icon24FolderOutline,
  },
  flapper_outline: {
    24: Icon24FlapperOutline,
  },
  sliders_outline: {
    20: Icon20SlidersOutline,
  },
  arrow_left_right_corners_outline: {
    24: Icon24ArrowLeftRightCornersOutline,
  },
  flag_finish: {
    24: Icon24FlagFinish,
  },
};
